import Injector from 'vue-inject';
import Debug from '@/util/debug';
import Vue from 'vue';
import { getStatus } from '@/util/sw-messages';

const debug = Debug('service:OfflineMode');

export default class OfflineModeService {
  constructor() {
    this.online = true;
    this.eventBus = new Vue();
    getStatus()
      .then(status => {
        this.setStatus(status); // On load set to previous status
      })
      .catch(err => debug.warn('ignored', err));
  }

  getEventBus() {
    return this.eventBus;
  }

  getStatus() {
    debug.info('getStatus %o', this.online);
    return this.online;
  }

  setStatus(online) {
    debug.info('setStatus status from %o to %o', this.online, online);
    this.online = online;
    this.eventBus.$emit('online-status', this.online);
  }
}

Injector.service('offlineModeService', null, OfflineModeService);



// WEBPACK FOOTER //
// ./src/services/OfflineModeService.js